export const messages = {
    nb: {

        creditRating: 'Kredittvurdering',

        checkTitle: `Kredittvurdering`,
        checkParagraph1: `Sjekk hvor betalingsdyktig kunden din er med en kredittvurdering.`,
        formFieldTitle: `Org nummer eller personnummer`,
        orgOrPersonNrLabel:  `Org eller personnummer`,
        prislisteTitle: 'Prisliste kredittvurdering',

        GH_name: 'Navn',
        GH_type: 'Type',
        GH_creditMark: 'Karakter',
        GH_creditScore: 'Score',
        GH_creditRating: 'Vurdering',
        GH_date: 'Dato kredittvurdering',
        GH_recommended: 'Anbefalt kredittgrense',
        GH_performNewCheck: 'Utfør ny kredittvurdering',
        GH_caseNumber: 'Fødselsnr/Orgnnr',
        GH_debtorNo: 'Debitornummer',
        GH_orgNumber: 'Organisasjonsnummer',
        GH_foretaksnavn: 'Foretaksnavn',
        GH_dagligLeder: 'Daglig leder',
        GH_styreleder: 'Styreleder',
        GH_styremedlem: 'Styremedlem',
        GH_nestleder: 'Nestleder',
        GH_category: 'Kategori',
        GH_friverdi: 'Friverdi',
        GH_amountFriverdi: 'Antall eiendeler',
        GH_missingData: 'Mangler data',
        GH_antallHeftelser: 'Antall heftelser',
        GH_eiendomstype: 'Eiendomstype',
        GH_formaal: 'Formål',
        GH_hjemmel: 'Hjemmel',
        GH_eierskapBroek: 'Eierskap brøk',
        GH_registerenhetId: 'Registerenhet id',
        GH_adresse: 'Adresse',
        GH_postnummer: 'Postnummer',
        GH_poststed: 'Poststed',
        GH_forrigeOmsetningstidspunkt: 'Forrige omsetningstidspunkt',
        GH_forrigeOmsetningspris: 'Forrige omsetningspris',
        GH_forrigeOmsetningsbroekverdi: 'Forrige omsetningspris brøkverdi',
        GH_estimertPris: 'Estimert pris',
        GH_brukstype: 'Brukstype',
        GH_boligtype: 'Boligtype',
        GH_kommunenummer: 'Kommunenummer',
        GH_gaardsnummer: 'Gårdsnummer',
        GH_bruksnummer: 'Bruksnummer',
        GH_aksjeklasse: 'Aksjeklasse',
        GH_antallAksjerEierskap: 'Antall aksjer eierskap',
        GH_totaltAntallAksjerSelskap: 'Totalt antall aksjer selskap',
        GH_andelEierskapBroek: 'Andel eierskap brøk',
        GH_kreditor: 'Kreditor',
        GH_saksnummer: 'Saksnummer',
        GH_registreringsdato: 'Registreringsdato',
        GH_oppgjoersstatus: 'Oppgjørsstatus',
        GH_oppgjoersdato: 'Oppgjørsdato',
        GH_inkassobyraa: 'Inkassobyrå',
        GH_typekode: 'Typekode',
        GH_typebeskrivelse: 'Typebeskrivelse',
        GH_sakshendelsetype: 'Sakshendelsetype',
        GH_beloep: 'Beløp',
        GH_beloepPerMnd: 'Beløp per måned',
        GH_startdato: 'Startdato',
        GH_sluttdato: 'Sluttdato',
        GH_saksoekerOrgnr: 'Saksøker orgnr',
        GH_saksoekerForetaksnavn: 'Saksøker foretaksnavn',
        GH_prosessfullmektigOrgnr: 'Prosessfullmektig orgnr',
        GH_prosessfullmektigForetaksnavn: 'Prosessfullmektig foretaksnavn',
        GH_namsmyndighetOrgnr: 'Namsmyndighet orgnr',
        GH_namsmyndighetForetaksnavn: 'Namsmyndighet foretaksnavn',
        GH_avholdtForretning: 'Avholdt forretning',
        GH_foedselsdato: 'Fødselsdato',
        GH_eierskapstype: 'Eierskapstype',
        GH_registreringsnummer: 'Registreringsnummer',
        GH_kjoeretoeyType: 'Kjøretøy type',
        GH_kjoeretoeyMerke: 'Kjøretøy merke',
        GH_kjoeretoeyModell: 'Kjøretøy modell',
        GH_foerstegangsregistrert: 'Førstegangsregistrert',
        GH_regStatus: 'Registrert status',
        GH_estimertPrisForhandler: 'Estimert pris forhandler',
        GH_estimertPrisPrivat: 'Estimert pris privat',
        GH_eksterneLinker: 'Eksterne linker',
        GH_nestleder: 'Nestleder',
        GH_innehaver: 'Innehaver',
        GH_documentNumber: 'Dokumentnummer',
        GH_lienType: 'Pant type',
        GH_enforced: 'Fullbyrdet',
        GH_totalLien: 'Total pant',
        GH_decisionTimestamp: 'Innkomsttidspunkt',
        GH_expiryDateLegalProtection: 'Utløps rettsverntid',
        GH_asset: 'Type',
        GH_roleOrgId: 'Pantehaver orgNr',
        GH_roleName: 'Pantehaver foretaksnavn',
        GH_roleOrgIdSetter: 'Pantesetter orgNr',
        GH_roleNameSetter: 'Pantesetter foretaksnavn',
        GH_id: 'ID',
        GH_legalFoundation: 'Lovgrunnlag',
        GH_directResponsibility: 'Direkte ansvar',
        GH_currency: 'Valuta',
        GH_updatedDate: 'Oppdatert dato',
        GH_registeredDate: 'Registrert dato',
        GH_registeredOnMultipleProperties: 'Registrert på flere eiendommer',
        GH_multipleDefendants: 'Flere saksøkte',
        GH_freeText: 'Fritekst',
        GH_districtCourt: 'Tingrett',
        GH_estateManager: 'Bobestyrer',
        GH_beskrivelse: 'Beskrivelse',
        GH_heftelseId: 'ID',
        GH_heftelseType: 'Type',
        GH_sharePant: 'Pantbrøk',
        GH_ownPant: 'Pantandel',
        GH_totalPant: 'Tot.pant',
        GH_estimatedSharePant: 'Est. pantandel',
        GH_estimatedTotalPant: 'Est. tot.pant',
        GH_orgnrClaimant: 'Søker org.nr.',
        GH_nameClaimant: 'Søker navn',
        GH_orgnrProcessAgent: 'Fullm. org.nr.',
        GH_nameProcessAgent: 'Fullm. navn',

        newCheckButton: 'Utfør kredittvurdering',
        updateListButton: 'Oppdater liste',
        updateCheckButton: 'Oppdater vurdering',
        showTermsButton: 'Vis avtale',
        openTermsButton: 'Les avtale',
        mustAcceptTitle: 'Avtale må godkjennes',
        cannotUpdatePersonButton: 'Rad mangler personnummer',
        cannotUpdateCompanyButton: 'Rad mangler orgnummer',
        typeLabel: 'Type',
        pnumberLabel: 'Personnummer',
        onumberLabel: 'Orgnummer',
        gradeLabel: 'Karakter',
        scoreLabel: 'Score',
        ratingLabel: 'Vurdering',
        colorRatingLabel: 'Rating',
        nameLabel: 'Navn',
        birthdayLabel: 'Fødselsdato',
        addressLabel: 'Adresse',
        postnumberLabel: 'Postnummer',
        municipalityLabel: 'Kommune',
        incomeLabel: 'Netto inntekt',
        fortuneLabel: 'Netto formue',
        taxLabel: 'Skatt',
        yearLabel: 'Ligningsår',
        number_remarksLabel: 'Antall anmerkninger',
        amount_remarksLabel: 'Beløp anmerkninger',
        styrelederLabel: 'Styreleder',
        styremedlemLabel: 'Styremedlem',
        dagliglederLabel: 'Daglig leder',
        estateLabel: 'Bolig',
        vehicleLabel: 'Motorvogn',
        enkLabel: 'Enk',
        ownerLabel: 'Eier AS',
        foretaksnavnLabel: 'Foretaksnavn',
        foundingdateLabel: 'Stiftelsesdato',
        orgnumberLabel: 'Organisasjonsnummer',
        orgformLabel: 'Organisasjonsform',
        industryLabel: 'Bransje',
        score_explanationLabel: 'Forklaring',
        recommended_limitLabel: 'Anbefalt kredittgrense',
        deactivate_title: 'Deaktiver kredittvurdering',
        revenues: 'Driftsinntekter',
        operating_costs: 'Driftskostnader',
        earnings: 'Driftsresultat',
        total_liabilities: 'Sum gjeld',
        total_equity: 'Sum egenkapital',
        total_assets: 'Sum eiendeler',
        financial_year: 'Regnskapsår',
        number_employees: 'Ansatte',
        creditCheck_failed: 'Noe gikk galt ved henting av kredittvurdering',
        howToCheck_title: 'Hvordan fungerer kredittvurdering?',
        howToCheck_text: 'Kredittopplysningsforetaket innhenter kredittopplysninger, blant annet om inntekt, gjeld, alder, bosted, jobbsituasjon og eventuelle betalingsanmerkninger eller inkassosaker, fra offentlige kilder. Basert på innhentet informasjon utarbeider kredittopplysningsforetaket en såkalt kredittscore som sier noe om personen eller foretaket som vurderes er kredittverdig. Du søker gjennom vår løsning, og vil bli etterfakturert for tjenesten. Raskt og enkelt!',
        openTerms_text: 'Om du ønsker å lese avtalen på nytt kan du trykke  ',
        termsAgreedDate_text: 'Avtale inngått',
        termsAgreedSigned_text: 'Signert av',
        download: 'Last ned PDF',
        refreshRow: 'Rad vil bli oppdatert når listen blir hentet på nytt.',
        accept_terms: 'Godta avtale',
        terms_caption: 'For å kunne bruke kredittvurdering må du først lese og godta avtalen under.',
        checkbox_text: 'Jeg godtar avtalen',
        accept: 'Godta',
        cancel: 'Avbryt',
        updateList_text: 'Oppdater søkehistorikk manuelt ved å trykke her',
        deactivateTitle: 'Deaktiver kredittvurdering',
        deactivateForUser: 'Om du ønsker å deaktivere kredittvurdering kan du trykke på "Deaktiver" under. Du kan alltids signere avtalen på nytt om ønskelig. ',
        deactivate_text: 'Om du ønsker å deaktivere kredittvurdering for denne bruker kan du trykke på knappen under.',
        deactivateKreditor_text: 'Du kan deaktivere kredittvurdering for innlogget bruker eller for valgt kreditor. ',
        deactivateKreditorButton: 'Kreditor',
        deactivateUserButton: 'Bruker',
        deactivateButton: 'Deaktiver',
        considerDownloading: 'Hele vurderingen finner du i det nedlastbare dokumentet.',

        confirm_action_title: 'Du er i ferd med å utføre en kredittvurdering!',
        confirm_action_person: 'En person som blir kredittvurdert, vil få et gjenpartsbrev som informerer om at det er gjort en slik vurdering og hvem som har utført sjekken. Tjenesten vil bli etterfakturert.',
        confirm_action_org: 'Tjenesten vil bli etterfakturert.',
        confirm_action_ok: 'Utfør kredittvurdering',
        confirm_action_cancel: 'Avbryt',

        kreditorNoSel: 'Ingen kreditor er valgt',
        filterNone: 'Ingen på listen',
        VelgKreditor: 'For å bruke kredittvurdering må du velge en kreditor fra nedtrekkslisten oppe til høyre.',
        ikkeKredittvurdering: 'Denne kreditoren har ikke signert avtale for å kunne bruke kredittvurdering. ',
        brukerIkkeKredittvurdering: 'Avtalen har blitt signert for kreditor, men bruker må også signere. ',
        ingenPåListen: 'Det er ingen på listen.',
        dineDebitorer: 'Dine debitorer',

        SH_Title: 'Søkehistorikk',
        SH_Date: 'Dato',
        SH_by: 'Utført av',
        SH_activity: 'Aktivitet',
        SH_Type: 'Type',
        SH_Name: 'Navn',
        SH_PersonOrg: 'Personnummer/Orgnr',
        SH_Version: 'Versjon',

        toastGetDebitorsFailed: 'Henting av debitorer for valgt kreditor feilet. ',
        toastGetDebitorsOk: 'Hentet debitorer for valgt kreditor',

        toastGetBasicDataFailed: 'Basisdata (valutakoder, landkoder og postnummerlist) feilet. ',
        toastGetBasicDataOk: 'Basisdata (valutakoder, landkoder og postnummerlist) hentet.',

        toastGetCompanyRatingFailed: 'Henting av kredittvurdering feilet. ',
        toastGetCompanyRatingOk: 'Hentet kredittvurdering for orgnummer ',

        toastGetPersonRatingFailed: 'Henting av kredittvurdering feilet. Sjekk om fødselsnummer ',
        toastGetPersonRatingOk: 'Hentet kredittvurdering for personnummer ',

        toastGetRatingInfoFailed: 'Sjekk om kreditor kan bruke kredittvurdering feilet. ',
        toastGetRatingInfoNoGo: 'Denne kreditor kan ikke bruke kredittvurdering. ',
        toastGetRatingInfoNoOrgNr: 'Organisasjonsnummer mangler på kreditor, vennligst ta kontakt med Kreditorforeningen ',
        toastGetRatingInfoOk: 'Denne kreditor har signert avtale for å kunne bruke kredittvurdering. ',
        toastGetRatingInfoRefreshOk: 'Søkehistorikk hentet på nytt for kreditor ',

        toastGetBislabTermsFailed: 'Henting av avtale feilet. ',
        toastGetBislabTermsOk: 'Hentet avtale for signering. ',

        toastAcceptRatingFailed: 'Signering av avtale feilet for bruker ',
        toastAcceptRatingOk: 'Avtalen har blitt signert for bruker ',

        toastUpdateDebtorRatingFailed: 'Oppdatering av kredittvurdering feilet for debitor ',
        toastUpdateDebtorRatingOk: 'Kredittvurdering har blitt oppdatert for debitor ',

        toastDeactivateDebtorRatingFailed: 'Deaktivering av kredittvurdering feilet for kreditor ',
        toastDeactivateDebtorRatingOk: 'Kredittvurdering har blitt deaktivert for kreditor ',
        toastDeactivateUseratingFailed: 'Deaktivering av kredittvurdering feilet for bruker ',
        toastDeactivateUserRatingOk: 'Kredittvurdering har blitt deaktivert for bruker ',

        toastNoUsersError: 'Ingen brukere funnen (en feil har oppstått',
        toastNoUsersFound: 'Ingen brukere tilfredstillet kriteriene',
        toastFoundUsers: 'Lastet ${poster} rader med brukere og kreditorer',    
        
        toastNoUserError: 'Kan ikke laste bruker (en feil har oppstått)',
        toastNoUserFound: 'Finner ikke bruker i database.',
        toastFoundUser: 'Brukerprofil lastet fra server.',

        toastUserHasBislab: 'Bruker har signert avtale for kredittvurdering',
        toastUserNoBislab: 'Bruker har ikke signert avtale for kredittvurdering',

        birthNumberLabel: 'Personnummer',
        birthNumberPlaceholder: 'Oppgi personnummer',
        birthNumberSmall: '11-sifret personnummer',

        orgNumberLabel: 'Orgnummer',
        orgNumberPlaceholder: 'Oppgi organisasjonsnummer',
        orgNumberSmall: '9-sifret organisasjonsnummer',

        debtorTypeLabel: 'Type',
        debtorTypePlaceholder: 'Velg type',
        debtorTypeSmall: '',

        chooseTypeLabel: 'Velg type først',
        chooseTypePlaceholder: '',
        chooseTypeSmall: '',


    }
}

